import * as ObjectUtil from 'helpers/object';

const TRUES = [1, 't', 'true', 'yes', 'on'].map(x => [x, true]).reduce(ObjectUtil.insertEntry, {});
const FALSES = [0, 'f', 'false', 'no', 'null', 'off', 'undefined', '']
  .map(x => [x, true])
  .reduce(ObjectUtil.insertEntry, {});

export function fromString(str) {
  return TRUES[String(str).toLowerCase()] || false;
}

export function isStringFalse(str) {
  return !!FALSES[String(str).toLowerCase()];
}
